import React from "react";
import { classHelper } from "../../utils/stringUtils";
import "./CardContainer.scss";

const CardContainer = ({ className, children, ...props }) => {
	return <div className={classHelper("card-container", className)}>{children || <></>}</div>;
};

export default CardContainer;
